import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import _ from 'lodash'
import Button from '../Button'
import List, { ListItem } from '../List'
import { H4, H6 } from '../TextPrimitives'
import { TextSmall } from '../TextPrimitives'
import { toRGBA } from '../../utils'
import { transparentUI } from '../../style-functions'

const CompanyName = styled(H4)`
  margin-bottom: 128px;
`
// TODO: (2) Should be h5 and looking like h6
const SectionTitle = styled(H6)`
  margin-bottom: 64px;
`

const Aside = styled.div`
  width: 864px;
  height: 1280px;
  position: relative;
  padding: 160px 96px 36px;
  background-image: linear-gradient(
    -29deg,
    ${({ theme }) => toRGBA(theme.colors.greys.dark, 0)} 0%,
    ${({ theme }) => toRGBA(theme.colors.primary.purple, 0.12)} 100%
  );
  border-radius: 0 16px 16px 0;
  color: ${({ theme }) => theme.colors.text.inverse};
  ${transparentUI};
`

const Controls = styled.div`
  position: absolute;
  bottom: 36px;
  width: calc(100% - 96px);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
`

const SectionButton = styled(Button)`
  display: inline-block;
  margin-right: 16px;
`

export const PROFILE_VIEW = 'Stammdaten'
export const TEXT_VIEW = 'Kurzgeschichte'
export const ADDRESS_VIEW = 'Adressen'
export const COMPANY_NAMES_VIEW = 'Umfirmierung'

/**
 * Card component that contains images, information, and a description of a company
 */
class ProfileAside extends Component {
  static defaultProps = {
    view: PROFILE_VIEW,
    onTextOpened: x => x,
  }

  static propTypes = {
    view: PropTypes.oneOf([
      TEXT_VIEW,
      PROFILE_VIEW,
      ADDRESS_VIEW,
      COMPANY_NAMES_VIEW,
    ]),
    company: PropTypes.object.isRequired,
    onTextOpened: PropTypes.func,
  }

  state = {
    view: null,
  }

  static getDerivedStateFromProps({ view }, state) {
    if (state.view === null) {
      return { view }
    }
    return null
  }

  handleViewChange = view => e => {
    this.setState({ view })
    if (view === TEXT_VIEW) {
      this.props.onTextOpened()
    }
  }

  get views() {
    const { text, addresses, companyNames } = this.props.company
    const views = {
      [TEXT_VIEW]: !!text,
      [ADDRESS_VIEW]: !!addresses,
      [COMPANY_NAMES_VIEW]: !!companyNames,
    }

    return _.keys(_.pickBy(views))
  }

  render() {
    const { company } = this.props
    const { view } = this.state
    const {
      name,
      existed,
      founder,
      products,
      addresses,
      currentAddress,
      companyNames,
      text,
    } = company
    const { current, historical } = currentAddress.names
    const views = [PROFILE_VIEW, ...this.views]

    return (
      <Aside>
        <CompanyName>{name}</CompanyName>
        <SectionTitle>{view === TEXT_VIEW ? text.title : view}</SectionTitle>
        {view === PROFILE_VIEW && (
          <List>
            <ListItem label="Existierte" text={existed} isTimeSpan={true} />
            {founder && <ListItem label="Gründer" text={founder} />}
            {products && <ListItem label="Produkte" text={products} />}
            <ListItem
              label="Adresse"
              text={
                historical === current
                  ? current
                  : [historical, `(heute ${current})`]
              }
            />
          </List>
        )}
        {view === TEXT_VIEW && <TextSmall>{text.body}</TextSmall>}
        {view === ADDRESS_VIEW && <List data={addresses} />}
        {view === COMPANY_NAMES_VIEW && <List data={companyNames} />}
        <Controls>
          {views.length > 1 &&
            views.map(label => (
              <SectionButton
                key={'button-' + label}
                size="small"
                type="rect"
                text={label}
                inverse={label !== view}
                onClick={this.handleViewChange(label)}
              />
            ))}
        </Controls>
      </Aside>
    )
  }
}

export default ProfileAside
